// extracted by mini-css-extract-plugin
module.exports = {"headline":"article_group_4-module--headline--1tiwl"};